
<div class="centered">
  <img class="logo" src="assets/ReportsFeed_Logo_Color.png" width="190" />
  <div class="welcome-content">
    <h2 i18n="@@welcomePageTitle">Welcome!</h2>
    <p i18n="@@welcomeText1">With the ReportsFeed it is possible to distribute reports generated in Power BI to the entire Organization.</p>
    <p i18n="@@welcomeText2">Complex filters can be applied to the applications in addition to scheduling dates, times and how often information is sent!</p>
    <p i18n="@@welcomeText3">Each person receives personalized content and in the right time. Image and PDF formats are available.</p>
    <p i18n="@@welcomeText4">Only ONE access to a Microsoft Power BI license is needed for the powerful features of the ReportsFeed be delivered.</p>
    <p i18n="@@welcomeText5">All of it with quality, performance and an excellent investment / benefit relation.</p>
    <p i18n="@@welcomeText6" class="highlight">Steps to Get Started:</p>
    <p>
      <span class="highlight"># 1</span>
      <span i18n="@@welcomeText7" class="left-space">License:</span>
      <span class="highlight left-space">{{ planData && planData.name ? planData.name : "Unknown" }}</span>
      <span i18n="@@welcomeText8" class="left-space">- Expiration Date:</span>
      <span class="highlight left-space">{{ planData && planData.planExpiration ? planData.planExpiration.toLocaleDateString() : "Unknown" }}</span>
      <span i18n="@@welcomeText9" class="left-space">- Monthly Limit:</span>
      <span class="highlight left-space">{{ planData && planData.deliveriesQuantity ? planData.deliveriesQuantity : "Unknown" }}</span>
    </p>
    <p>
      <span class="highlight"># 2</span>
      <span i18n="@@welcomeText10" class="left-space">Connect ReportsFeed to the service with only a Microsoft Power BI license.</span>
    </p>
    <p>
      <span class="highlight"># 3</span>
      <span i18n="@@welcomeText11" class="left-space">Enter the necessary permissions to access Microsft Power BI applications which will integrate with the ReportsFeed (our configurator guides you to do so)</span>
    </p>
    <span i18n="@@welcomeText12">Let's get started!</span>
    <button class="btn btn-primary left-space" (click)="onRedirectButtonClick()" i18n="Label in the button used to navigate to activate PowerBI connection@@welcomeActivateActionButtonLabel">Activate PowerBI Connection</button>
  </div>
</div>
